import React, { useState } from 'react';
import { runAllTests, testBasicFunction, testStripeCheckout, testSubscriptionStatus, testWebhook } from '../utils/testNetlifyFunctions';
import './TestFunctionsPage.css';

const TestFunctionsPage = () => {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleRunAllTests = async () => {
    setLoading(true);
    setError(null);
    try {
      const testResults = await runAllTests();
      setResults(testResults);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTestBasicFunction = async () => {
    setLoading(true);
    setError(null);
    try {
      const testResult = await testBasicFunction();
      setResults({ basicFunction: testResult });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTestStripeCheckout = async () => {
    setLoading(true);
    setError(null);
    try {
      const testResult = await testStripeCheckout();
      setResults({ stripeCheckout: testResult });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTestSubscriptionStatus = async () => {
    setLoading(true);
    setError(null);
    try {
      const testResult = await testSubscriptionStatus();
      setResults({ subscriptionStatus: testResult });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <h1>Netlify Functions Test</h1>
        <p>Use this page to test Netlify Functions and diagnose issues.</p>

        <div className="test-buttons">
          <button 
            className="btn btn-primary" 
            onClick={handleRunAllTests}
            disabled={loading}
          >
            Run All Tests
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={handleTestBasicFunction}
            disabled={loading}
          >
            Test Basic Function
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={handleTestStripeCheckout}
            disabled={loading}
          >
            Test Stripe Checkout
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={handleTestSubscriptionStatus}
            disabled={loading}
          >
            Test Subscription Status
          </button>
          <button 
            className="btn btn-secondary" 
            onClick={() => {
              setLoading(true);
              setError(null);
              testWebhook()
                .then(result => setResults({ webhook: result }))
                .catch(err => setError(err.message))
                .finally(() => setLoading(false));
            }}
            disabled={loading}
          >
            Test Webhook
          </button>
        </div>

        {loading && (
          <div className="loading">
            <p>Running tests...</p>
          </div>
        )}

        {error && (
          <div className="error">
            <h3>Error:</h3>
            <p>{error}</p>
          </div>
        )}

        {results && (
          <div className="results">
            <h3>Test Results:</h3>
            <pre>{JSON.stringify(results, null, 2)}</pre>
          </div>
        )}

        <div className="troubleshooting">
          <h3>Troubleshooting Tips:</h3>
          <ul>
            <li>Check if the basic test function works. If it does, the issue is specific to the Stripe functions.</li>
            <li>Verify that all environment variables are set correctly in Netlify.</li>
            <li>Check the Netlify function logs for detailed error messages.</li>
            <li>Make sure the function dependencies are installed correctly.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TestFunctionsPage;
